import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import axios from '../../utils/axios';
import { User } from '../../@types/user';

type UserResponse = {
  data: any;
  type: string;
};

type UserState = {
  isLoading: boolean;
  error: any;
  user: User | null;
  response: UserResponse | null;
};

const initialState: UserState = {
  isLoading: false,
  error: null,
  user: null,
  response: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    reset(state) {
      state.isLoading = false;
      state.error = null;
      state.response = null;
      state.user = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getUserSuccess(state, action) {
      state.isLoading = false;
      state.user = action.payload.data;
      state.response = {
        data: action.payload.data,
        type: 'GET_USER_SUCCESS'
      };
    },
    updateUserImageSuccess(state, action) {
      state.isLoading = false;
      state.user = action.payload.data;
      state.response = {
        data: action.payload.data,
        type: 'UPDATE_USER_IMAGE_SUCCESS'
      };
    }
  }
});

// Reducer
export default slice.reducer;

// Actions

export const updateUserProfileImage = (userId: string, formData: FormData) => async () => {
  dispatch(slice.actions.startLoading());
  try {
    const response = await axios.put(`/user/${userId}/update-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    dispatch(slice.actions.updateUserImageSuccess(response.data));
  } catch (error: any) {
    dispatch(slice.actions.hasError(error));
  }
};

export const resetUserState = () => async () => {
  dispatch(slice.actions.reset());
};
